import { Dialog, useMobileBreakpoint } from '@customink/pigment-react';
import { DialogProps } from '@customink/pigment-react/lib/components/Dialog/Dialog';

type ResponsiveDialogProps = Omit<DialogProps, 'fullScreen'>;

export function ResponsiveDialog({ ...props }: ResponsiveDialogProps) {
    const isMobileView = useMobileBreakpoint();
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <Dialog fullScreen={isMobileView} {...props} />;
}
